import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.StrategyView.heading',
    defaultMessage: 'Strategia'
  },
  profitTitle: {
    id: 'views.StrategyView.profitTitle',
    defaultMessage:
      'Przyjęta na lata 2022-2025 strategia Grupy TenderHut zakłada dalszy dynamiczny rozwój poprzez koncentrację na: '
  }
});



// WEBPACK FOOTER //
// ./src/views/Strategy/StrategyView.intl.js